<template>
  <v-app>
    <!-- <div id="app"> -->
    <router-view :key="$route.fullPath" />
    <!-- </div> -->
  </v-app>
</template>

<script>
export default {
  name: 'App',

  components: {

  },

  data: () => ({
    //
  }),
  watch: {
    '$route': {
      async handler(to) {
        await this.getMenu()
        if(this.$route.path == '/news/list'){
          this.$Bus.$emit('updateNews')
        }else if(this.$route.path == '/expertise/list/technical' || this.$route.path == '/expertise/list/resource'){
          this.$Bus.$emit('updateTechnical')
        }else if(this.$route.path.indexOf('/about/list') > -1){
          this.$Bus.$emit('updateAbout')
        }
        if(to.name == 'informationListCode' || to.name == 'informationListDetail'){
          this.$Bus.$emit('updateInformationListCode')
        }
      }
    },
  },
  async mounted() {
    await this.init()

  },
  methods: {

    async init() {
      if (location && location.origin) {
        if (location.origin.indexOf('www.nast.com.cn') > -1 || location.origin.indexOf('dongfengdaan.qixiuu.com') > -1 || location.origin.indexOf('localhost') > -1 || location.origin.indexOf('192.168.111') > -1) {
          this.$i18n.locale = 'zh-CN'
          localStorage.setItem('change-language', 'zh-CN')
        } else {
          this.$i18n.locale = 'en'
          localStorage.setItem('change-language', 'en')
        }
      } else {
        this.$i18n.locale = 'zh-CN'
        localStorage.setItem('change-language', 'zh-CN')
      }
      await this.getMenu()
    }
  }
};
</script>
<style lang="scss">

.v-btn {
  text-transform: none !important;
  letter-spacing:0px!important;
}

.v-text-field--filled.v-input--dense.v-text-field--single-line>.v-input__control>.v-input__slot,
.v-text-field--filled.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot,
.v-text-field--filled.v-input--dense.v-text-field--outlined.v-text-field--filled>.v-input__control>.v-input__slot,
.v-text-field--full-width.v-input--dense.v-text-field--single-line>.v-input__control>.v-input__slot,
.v-text-field--full-width.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot,
.v-text-field--full-width.v-input--dense.v-text-field--outlined.v-text-field--filled>.v-input__control>.v-input__slot,
.v-text-field--outlined.v-input--dense.v-text-field--single-line>.v-input__control>.v-input__slot,
.v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot,
.v-text-field--outlined.v-input--dense.v-text-field--outlined.v-text-field--filled>.v-input__control>.v-input__slot {
  min-height: 40px !important;
}

.v-breadcrumbs--large li {
  font-size: 16px !important;
}



.v-text-field .v-input__prepend-inner,
.v-text-field .v-input__append-inner {
  margin-top: 15px !important;
}

.linklist {

  .v-text-field .v-input__prepend-inner,
  .v-text-field .v-input__append-inner {
    margin-top: 10px !important;
  }
}



.v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}

.v-input__slot {
  margin-bottom: 0px !important;
}

.ql-editor img {
  max-width: 100%;
}

@keyframes loading {
  0% {
    content: "";
  }

  10% {
    content: ".";
  }

  40% {
    content: "..";
  }

  70% {
    content: "...";
  }

  100% {
    content: "";
  }
}

body {
  font-family: Source Han Sans CN-Regular
}
.v-application{
    font-family: Source Han Sans CN-Regular!important;
    line-height: unset!important;
}
.v-application .v-breadcrumbs__item {
  color: #333333 !important;
}

.v-application .v-breadcrumbs__item--disabled {
  color: #666666 !important;
}
.body-desktop{

  .containers {
    width: 1600px;
    margin: 0 auto;
  }
  .v-list-item__title {
    font-size: 16px !important;
  }
  .v-btn:not(.v-btn--round).v-size--default {
    height: 38px !important;
    min-width: 64px !important;
    padding: 0 16px !important;
  }
}


.line-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.line-2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.line-3 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.line-4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

.line-5 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

.line-7 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
}

.line-9 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 9;
  -webkit-box-orient: vertical;
}

.line-10 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
}

*::-webkit-scrollbar {
  width: 14px;
  height: 14px;
}

*::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}

*::-webkit-scrollbar-corner {
  background-color: transparent;
}

*::-webkit-scrollbar-thumb {
  min-height: 12px;
  border: 4px solid transparent;
  background-clip: content-box;
  border-radius: 7px;
  background-color: #c8d5e1;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #a8bbcf;
}

*::-webkit-scrollbar-thumb:active {
  background-color: #87a2bd;
}

*::-webkit-scrollbar-track {
  background-color: transparent;
}

*::-webkit-scrollbar-track-piece {
  background-color: transparent;
}

.body-mobile{

  .v-application--wrap{
    min-height: 10vh!important;
  }
  .v-icon__svg{
    width: 0.2rem;
    height: 0.2rem;
  }
  .v-application{
    font-family: unset!important;
    line-height: unset!important;
    .title{
      font-size: unset!important;
      font-weight: unset!important;
      line-height: unset!important;
      letter-spacing: unset !important;
      font-family: unset!important;
    }
  }
  .containers{
    width: 95%;
    margin:0 auto;
    box-sizing: border-box;
  }
  .v-list-item__title {
    font-size:0.24rem!important;
  }
  .v-responsive__content{
    width: 100%!important;
  }
  .v-window__next, .v-window__prev{
    width: 0.6rem!important;
    height: 0.6rem!important;
    top:50%!important;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateY(-50%)!important;
    .v-btn--icon.v-size--default .v-icon, .v-btn--fab.v-size--default .v-icon{
      font-size: 0.40rem!important;
    }
  }
  .v-btn:not(.v-btn--round).v-size--default {
    // height: 0.76rem !important;
    // min-width: 1.28rem!important;
    // padding: 0 0.32rem!important;
       height: unset !important;
    min-width: unset!important;
    padding: unset!important;
  }
  .online-service-dialog{
    .v-textarea textarea{
        line-height: 16px;
        min-height: unset!important;
        font-size: 12px;
        height: 32px!important;
    }
    .v-text-field.v-text-field--solo .v-input__control{
      height: 32px!important;
    }
  }
}


</style>
